export const defaultColDef = Object.freeze({
    lockPinned: true,
    suppressSizeToFit: false,
});

export const defaultGeneralTimeframe = [
    {
        dayOfWeek: "Monday",
        isOpen: false,
        opening: null,
        breakFrom: null,
        breakTo: null,
        closing: null
    },
    {
        dayOfWeek: "Tuesday",
        isOpen: false,
        opening: null,
        breakFrom: null,
        breakTo: null,
        closing: null
    },
    {
        dayOfWeek: "Wednesday",
        isOpen: false,
        opening: null,
        breakFrom: null,
        breakTo: null,
        closing: null
    },
    {
        dayOfWeek: "Thursday",
        isOpen: false,
        opening: null,
        breakFrom: null,
        breakTo: null,
        closing: null
    },
    {
        dayOfWeek: "Friday",
        isOpen: false,
        opening: null,
        breakFrom: null,
        breakTo: null,
        closing: null
    },
    {
        dayOfWeek: "Saturday",
        isOpen: false,
        opening: null,
        breakFrom: null,
        breakTo: null,
        closing: null
    },
    {
        dayOfWeek: "Sunday",
        isOpen: false,
        opening: null,
        breakFrom: null,
        breakTo: null,
        closing: null
    }
];
